import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { render as x, html as $, nothing as w } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { unsafeHTML as o } from '../../../../node_modules/lit-html/directives/unsafe-html.js';
import css_248z from './cards-carousel.scss.js';
import img from '../../../../assets/images/mep-default.png.js';
import { CardItem } from './card-item.js';

const PORTAL_ID = 'cvt-card-gallery-modal-portal';
const STYLE_ID = 'cvt-card-gallery-modal-styles';
const modalPortalCss = `
.gallery-modal-overlay {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.55);
  z-index: 9999;
}
.gallery-modal {
  position: relative;
  width: 100%;
  max-width: 720px;
  max-height: 930px;
}
.gallery-modal-container {
  position: relative;
  width: 100%;
  background: #ffffff;
  border-radius: 40px;
  overflow: hidden;
}
.gallery-modal-close {
  position: relative;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border: 0px;
  background-color: rgb(255, 255, 255);
  font-size: 32px;
  cursor: pointer;
  display: flex;
  margin-left: auto;
  padding: unset;
  justify-content: center;
  margin-bottom: 16px;
  padding-top: 6px;
  color: #333;
}
.gallery-modal-close:hover {
  background-color: rgba(111, 37, 149, 1);
  color: #fff;
}
.gallery-modal-scroll {
  max-height: 70vh;
  overflow-y: auto;
  padding: 48px;
}
.gallery-modal-title {
  color: #333;
  font-family: 'Codec Warm', sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 600;
  line-height: 60px;
  margin-bottom: 32px;
  margin-top: unset;
}
.gallery-modal-meta {
  color: #333;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 24px;
}
.gallery-modal-description,
.gallery-modal-description p {
  color: #333 !important;
  font-family: 'Noto Sans', sans-serif !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 24px !important;
}
.gallery-modal-actions {
  display: flex;
  gap: 32px;
  margin-top: 32px;
  justify-content: space-between;
}
.gallery-modal-tags {
  color: #666;
  font-family: 'Noto Sans', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.gallery-modal-cta {
  display: flex;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 27px;
  border-radius: 4px;
  cursor: pointer;
  text-decoration: none;
}
.gallery-modal-cta-primary {
  background: #6f2595;
  color: #fff;
}
.gallery-modal-cta-primary:hover {
  background: rgba(111, 37, 149, 0.9);
}
.gallery-modal-cta-secondary {
  border: 2px solid #6f2595;
  background: #fff;
  color: #6f2595;
}
.gallery-modal-cta-secondary:hover {
  background: #f5f5f5;
}
.gallery-modal-image {
  margin-top: 32px;
}
.gallery-modal-image img {
  object-fit: cover;
  width: 100%;
  border-radius: 9.5px;
  aspect-ratio: 187/105;
}
`;
function ensureModalPortalStyles(cssText) {
    if (typeof document === 'undefined')
        return;
    if (document.getElementById(STYLE_ID))
        return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = cssText;
    document.head.appendChild(style);
}
function getOrCreateModalPortal() {
    const existing = document.getElementById(PORTAL_ID);
    if (existing)
        return existing;
    const container = document.createElement('div');
    container.id = PORTAL_ID;
    document.body.appendChild(container);
    return container;
}
function removeModalPortalIfEmpty() {
    const container = document.getElementById(PORTAL_ID);
    if (!container)
        return;
    if (!container.hasChildNodes())
        container.remove();
}
function renderCard(card, onOpen) {
    const hasDescription = Boolean(card.meta);
    const hasLink = Boolean(card.modalPrimaryCtaLink);
    const imageTemplate = $ `<div class="gallery-card-image"><img src="${card.imageSrc || img}" alt="${card.imageAlt || ''}" loading="lazy"></div>`;
    const descriptionTemplate = hasDescription
        ? $ `<div class="gallery-card-description">${card.meta}</div>`
        : w;
    const linkTemplate = hasLink
        ? $ `<span class="gallery-card-link">Link <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" class="arrow-icon"><path d="M6.18899 22.2675C5.83383 21.9123 5.65625 21.4603 5.65625 20.9114C5.65625 20.3625 5.83383 19.9105 6.18899 19.5554L13.7441 12.0002L6.18899 4.44504C5.83383 4.08988 5.65625 3.63786 5.65625 3.08898C5.65625 2.54011 5.83383 2.08809 6.18899 1.73293C6.54414 1.37777 6.99616 1.2002 7.54504 1.2002C8.09392 1.2002 8.54594 1.37777 8.90109 1.73293L17.8123 10.6441C18.006 10.8379 18.1432 11.0477 18.224 11.2737C18.3047 11.4997 18.345 11.7419 18.345 12.0002C18.345 12.2585 18.3047 12.5006 18.224 12.7267C18.1432 12.9527 18.006 13.1625 17.8123 13.3562L8.90109 22.2675C8.54594 22.6226 8.09392 22.8002 7.54504 22.8002C6.99616 22.8002 6.54414 22.6226 6.18899 22.2675Z" fill="#6f2595"/></svg></span>`
        : w;
    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onOpen(card);
        }
    };
    return $ `<article class="gallery-card"><button class="gallery-card-button" type="button" @click="${() => onOpen(card)}" @keydown="${handleKeyDown}" aria-label="${card.title}">${imageTemplate}<div class="gallery-card-content"><h3 class="gallery-card-title">${card.title}</h3>${descriptionTemplate} ${linkTemplate}</div></button></article>`;
}
/* eslint-disable sonarjs/cognitive-complexity */
function renderCourseModal(isOpen, activeItem, onClose) {
    if (!isOpen || !activeItem) {
        return w;
    }
    const title = activeItem.title || '';
    const metaText = activeItem.meta || '';
    const description = activeItem.description || '';
    const imageSrc = activeItem.imageSrc || '';
    const imageAlt = activeItem.imageAlt || title;
    const primaryCtaLink = activeItem.modalPrimaryCtaLink || '';
    const primaryCtaLabel = activeItem.modalPrimaryCtaLabel || '';
    const secondaryCtaLink = activeItem.modalSecondaryCtaLink || '';
    const secondaryCtaLabel = activeItem.modalSecondaryCtaLabel || '';
    const tags = Array.isArray(activeItem.tags) ? activeItem.tags : [];
    const onOverlayClick = (event) => {
        const target = event.target;
        if (target && target.classList.contains('gallery-modal-overlay')) {
            onClose();
        }
    };
    const stopPropagation = (event) => {
        event.stopPropagation();
    };
    const metaTemplate = metaText
        ? $ `<div class="gallery-modal-meta">${metaText}</div>`
        : w;
    const descriptionTemplate = description
        ? $ `<div class="gallery-modal-description">${o(description)}</div>`
        : w;
    let tagsTemplate = w;
    if (tags.length) {
        const tagItems = tags.map((tag, index) => {
            const isLast = index === tags.length - 1;
            return isLast
                ? $ `<span class="gallery-modal-tag">${tag}</span>`
                : $ `<span class="gallery-modal-tag">${tag}</span><span> - </span>`;
        });
        tagsTemplate = $ `<div class="gallery-modal-tags" aria-label="Tags">${tagItems}</div>`;
    }
    const primaryCta = primaryCtaLink
        ? $ `<a class="gallery-modal-cta gallery-modal-cta-primary" href="${primaryCtaLink}" target="_blank" rel="noopener noreferrer">${primaryCtaLabel}</a>`
        : w;
    const secondaryCta = secondaryCtaLink
        ? $ `<a class="gallery-modal-cta gallery-modal-cta-secondary" href="${secondaryCtaLink}" target="_blank" rel="noopener noreferrer">${secondaryCtaLabel}</a>`
        : w;
    const imageTemplate = imageSrc
        ? $ `<div class="gallery-modal-image"><img src="${imageSrc}" alt="${imageAlt}" loading="lazy"></div>`
        : w;
    return $ `<div class="gallery-modal-overlay" role="presentation" @click="${onOverlayClick}"><div class="gallery-modal"><button class="gallery-modal-close" type="button" aria-label="Close" @click="${onClose}">×</button><section class="gallery-modal-container" role="dialog" aria-modal="true" aria-label="${title}" @click="${stopPropagation}" @keydown="${(event) => {
        if (event.key === 'Escape')
            onClose();
    }}"><div class="gallery-modal-scroll"><div class="gallery-modal-content"><h2 class="gallery-modal-title">${title}</h2>${metaTemplate} ${descriptionTemplate} ${tagsTemplate}<div class="gallery-modal-actions">${primaryCta} ${secondaryCta}</div>${imageTemplate}</div></div></section></div></div>`;
}
const ChevronLeft = (disabled) => $ `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${disabled ? '#000000' : '#ffffff'}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>`;
const ChevronRight = (white) => $ `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${white ? '#ffffff' : '#000000'}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>`;
class CardsCarousel extends s {
    constructor() {
        super(...arguments);
        this.title = '';
        this.description = '';
        this.cardsPerPage = 3;
        this.cards = [];
        this.currentPage = 1;
        this.isModalOpen = false;
        this.activeItem = null;
        this.stripStyle = '';
        this.isMobile = false;
        this.mobileGridStyle = '';
        this.isAnimating = false;
        this.onMobileChange = (e) => {
            this.isMobile = e.matches;
            this.currentPage = 1;
            this.mobileGridStyle = '';
            this.stripStyle = '';
        };
        this.handleEscapeKey = (event) => {
            if (event.key === 'Escape' && this.isModalOpen)
                this.closeModal();
        };
        this.openModal = (item) => {
            this.activeItem = item;
            this.isModalOpen = true;
            document.body.style.overflow = 'hidden';
        };
        this.closeModal = () => {
            this.isModalOpen = false;
            this.activeItem = null;
            document.body.style.overflow = '';
        };
    }
    get effectiveCardsPerPage() {
        return this.isMobile ? 1 : this.cardsPerPage;
    }
    get totalPages() {
        return Math.max(1, Math.ceil(this.cards.length / this.effectiveCardsPerPage));
    }
    getPageStartIndex(page) {
        const rawStart = (page - 1) * this.effectiveCardsPerPage;
        const maxStart = Math.max(0, this.cards.length - this.effectiveCardsPerPage);
        return Math.min(rawStart, maxStart);
    }
    getCardsForPage(page) {
        const start = this.getPageStartIndex(page);
        return this.cards.slice(start, start + this.effectiveCardsPerPage);
    }
    getPeekCard(page) {
        var _a;
        if (!this.isMobile || page >= this.totalPages)
            return null;
        return (_a = this.getCardsForPage(page + 1)[0]) !== null && _a !== void 0 ? _a : null;
    }
    getMobilePrevCard() {
        var _a;
        if (!this.isMobile || this.currentPage <= 1)
            return null;
        const prevCards = this.getCardsForPage(this.currentPage - 1);
        return (_a = prevCards[prevCards.length - 1]) !== null && _a !== void 0 ? _a : null;
    }
    onSlotChange(event) {
        const slot = event.target;
        const cardItems = [];
        slot.assignedElements().forEach(el => {
            if (el.tagName.toLowerCase() === 'card-item' && el instanceof CardItem) {
                cardItems.push(el.toCardItem());
            }
        });
        this.cards = cardItems;
        this.currentPage = 1;
        this.stripStyle = '';
    }
    renderCards(page) {
        const templates = [];
        this.getCardsForPage(page).forEach(card => {
            templates.push(renderCard(card, this.openModal));
        });
        return templates;
    }
    recalcStripOffset() {
        var _a;
        if (this.isMobile || this.currentPage <= 1) {
            this.stripStyle = '';
            return;
        }
        const startIndex = this.getPageStartIndex(this.currentPage);
        const card = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.carousel-strip > .gallery-card');
        if (!card)
            return;
        const gap = 32;
        const offset = startIndex * (card.offsetWidth + gap);
        this.stripStyle = offset === 0 ? '' : `transform: translateX(-${offset}px)`;
    }
    connectedCallback() {
        super.connectedCallback();
        ensureModalPortalStyles(modalPortalCss);
        window.addEventListener('keydown', this.handleEscapeKey);
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.isMobile = this.mobileQuery.matches;
        this.mobileQuery.addEventListener('change', this.onMobileChange);
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        window.removeEventListener('keydown', this.handleEscapeKey);
        (_a = this.mobileQuery) === null || _a === void 0 ? void 0 : _a.removeEventListener('change', this.onMobileChange);
        if (typeof window !== 'undefined') {
            this.isModalOpen = false;
            this.activeItem = null;
            this.syncModalPortal();
        }
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('isModalOpen') ||
            changedProperties.has('activeItem')) {
            this.syncModalPortal();
        }
    }
    syncModalPortal() {
        if (typeof window === 'undefined')
            return;
        const portal = getOrCreateModalPortal();
        x(renderCourseModal(this.isModalOpen, this.activeItem, this.closeModal), portal);
        if (!this.isModalOpen)
            removeModalPortalIfEmpty();
    }
    navigate(direction) {
        if (this.isAnimating)
            return;
        if (this.isMobile) {
            this.navigateMobile(direction);
        }
        else {
            this.navigateDesktop(direction);
        }
    }
    navigateDesktop(direction) {
        var _a;
        const nextPage = direction === 'next' ? this.currentPage + 1 : this.currentPage - 1;
        if (nextPage < 1 || nextPage > this.totalPages)
            return;
        this.isAnimating = true;
        this.currentPage = nextPage;
        const startIndex = this.getPageStartIndex(nextPage);
        const card = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.carousel-strip > .gallery-card');
        const gap = 32;
        const cardWidth = card ? card.offsetWidth : 280;
        const offset = startIndex * (cardWidth + gap);
        this.stripStyle =
            offset === 0
                ? 'transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
                : `transform: translateX(-${offset}px); transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)`;
        setTimeout(() => {
            this.isAnimating = false;
        }, 400);
    }
    completeMobileNavigation(nextPage, targetOffset, slotWidth) {
        this.mobileGridStyle = `transform: translateX(${targetOffset}px); transition: none`;
        this.currentPage = nextPage;
        requestAnimationFrame(() => this.snapToMobileRestOffset(nextPage, slotWidth));
    }
    snapToMobileRestOffset(nextPage, slotWidth) {
        const newRestOffset = nextPage > 1 ? -slotWidth : 0;
        requestAnimationFrame(() => {
            this.mobileGridStyle =
                newRestOffset !== 0 ? `transform: translateX(${newRestOffset}px)` : '';
            this.isAnimating = false;
        });
    }
    navigateMobile(direction) {
        var _a;
        const nextPage = direction === 'next' ? this.currentPage + 1 : this.currentPage - 1;
        if (nextPage < 1 || nextPage > this.totalPages)
            return;
        this.isAnimating = true;
        const currentCard = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.gallery-grid > .gallery-card');
        const cardWidth = currentCard ? currentCard.offsetWidth : 280;
        const slotWidth = cardWidth + 16;
        const currentOffset = this.currentPage > 1 ? -slotWidth : 0;
        const targetOffset = direction === 'next'
            ? currentOffset - slotWidth
            : currentOffset + slotWidth;
        this.mobileGridStyle = `transform: translateX(${currentOffset}px); transition: none`;
        requestAnimationFrame(() => {
            this.mobileGridStyle = `transform: translateX(${targetOffset}px); transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)`;
            setTimeout(() => this.completeMobileNavigation(nextPage, targetOffset, slotWidth), 400);
        });
    }
    renderMobileGrid() {
        const prevCard = this.getMobilePrevCard();
        const nextCard = this.getPeekCard(this.currentPage);
        const idleOffset = (() => {
            var _a;
            if (this.mobileGridStyle !== '')
                return this.mobileGridStyle;
            if (!prevCard)
                return '';
            const card = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.gallery-grid > .gallery-card');
            const offset = card ? -(card.offsetWidth + 16) : 0;
            return offset !== 0 ? `transform: translateX(${offset}px)` : '';
        })();
        return $ `<div class="carousel-outer is-mobile"><div class="carousel-viewport"><div class="gallery-grid" style="${idleOffset}">${prevCard
            ? $ `<div class="carousel-peek carousel-peek--prev">${renderCard(prevCard, this.openModal)}</div>`
            : w} ${this.renderCards(this.currentPage)} ${nextCard
            ? $ `<div class="carousel-peek carousel-peek--next">${renderCard(nextCard, this.openModal)}</div>`
            : w}</div></div></div>`;
    }
    renderGrid() {
        if (this.isMobile) {
            return this.renderMobileGrid();
        }
        return $ `<div class="carousel-outer"><div class="carousel-viewport"><div class="gallery-grid carousel-strip" style="${this.stripStyle || 'transform: translateX(0)'}">${this.cards.map(card => renderCard(card, this.openModal))}</div></div></div>`;
    }
    renderPagination() {
        if (this.totalPages <= 1)
            return w;
        const isFirst = this.currentPage === 1;
        const isLast = this.currentPage === this.totalPages;
        return $ `<nav class="carousel-pagination" aria-label="Carousel pagination"><button class="carousel-pagination-prev" ?disabled="${isFirst}" @click="${() => this.navigate('prev')}" aria-label="Previous page">${ChevronLeft(isFirst)}</button><div class="pagination-counter" aria-live="polite" aria-atomic="true"><span class="current-page">${this.currentPage}</span> <span class="page-separator"> / </span><span class="total-pages">${this.totalPages}</span></div><button class="carousel-pagination-next" ?disabled="${isLast}" @click="${() => this.navigate('next')}" aria-label="Next page">${ChevronRight(!isLast)}</button></nav>`;
    }
    render() {
        return $ `${this.title
            ? $ `<h2 class="carousel-title">${this.title}</h2>`
            : w} ${this.description
            ? $ `<p class="carousel-description">${this.description}</p>`
            : w} ${this.renderGrid()} ${this.renderPagination()}<slot @slotchange="${this.onSlotChange}" style="display:none"></slot>`;
    }
}
CardsCarousel.styles = css_248z;
__decorate([
    e({ type: String })
], CardsCarousel.prototype, "title", void 0);
__decorate([
    e({ type: String })
], CardsCarousel.prototype, "description", void 0);
__decorate([
    e({ type: Number })
], CardsCarousel.prototype, "cardsPerPage", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "cards", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "currentPage", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "isModalOpen", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "activeItem", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "stripStyle", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "isMobile", void 0);
__decorate([
    t()
], CardsCarousel.prototype, "mobileGridStyle", void 0);
customElements.define('cards-carousel', CardsCarousel);

export { CardsCarousel };
